(() => {
  const root = document.querySelector('[data-pocketry-google-ready-product]');
  if (!root) return;

  const mainImage = root.querySelector('.pgrp__main-image');
  const galleryStatus = root.querySelector('.pgrp__gallery-status');
  const relatedOutfits = root.querySelector('[data-related-outfits]');

  if (relatedOutfits) {
    const outfits = Array.from(relatedOutfits.querySelectorAll('template[data-related-outfit]'));
    for (let index = outfits.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [outfits[index], outfits[randomIndex]] = [outfits[randomIndex], outfits[index]];
    }
    outfits.slice(0, 4).forEach((outfit) => {
      relatedOutfits.append(outfit.content.cloneNode(true));
    });
  }

  // ── Desktop stage + thumbnails (unchanged behaviour) ───────────────────
  let previewBadge = null;
  // Desktop: a video thumbnail swaps the stage image for the player; an image thumbnail restores it (2026-09-13).
  const stageEl = root.querySelector('.pgrp__stage');
  let stageVideo = null;
  const clearStageVideo = () => { if (stageVideo) { stageVideo.pause(); stageVideo.remove(); stageVideo = null; } if (mainImage) mainImage.hidden = false; };
  // Desktop counter (2026-09-14): "n / total" in the stage's upper-right corner, like the mobile swipe gallery.
  const stageCount = root.querySelector('[data-stage-count]');
  const galleryButtons = Array.from(root.querySelectorAll('[data-gallery-image]'));
  const setStageCount = (index) => { if (stageCount && galleryButtons.length > 1) stageCount.textContent = `${index + 1} / ${galleryButtons.length}`; };
  setStageCount(0);
  let stageIndex = 0;
  const stepStage = (delta) => { if (!galleryButtons.length) return; stageIndex = (stageIndex + delta + galleryButtons.length) % galleryButtons.length; galleryButtons[stageIndex].click(); galleryButtons[stageIndex].scrollIntoView({ block: 'nearest' }); };
  root.querySelector('[data-stage-prev]')?.addEventListener('click', () => stepStage(-1));
  root.querySelector('[data-stage-next]')?.addEventListener('click', () => stepStage(1));
  document.addEventListener('keydown', (e) => {
    if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
    if (!stageEl || !stageEl.getClientRects().length) return;
    if (e.key === 'ArrowLeft') stepStage(-1); else if (e.key === 'ArrowRight') stepStage(1);
  });
  // the thumbnail rail never grows taller than the stage; it scrolls instead
  const rail = root.querySelector('.pgrp__thumbnails');
  const fitRail = () => { if (rail && stageEl && stageEl.getClientRects().length) rail.style.maxHeight = `${stageEl.offsetHeight}px`; };
  fitRail(); window.addEventListener('resize', fitRail); if (mainImage) mainImage.addEventListener('load', fitRail);
  root.querySelectorAll('[data-gallery-image]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!mainImage) return;
      stageIndex = galleryButtons.indexOf(button); setStageCount(stageIndex);
      window.dispatchEvent(new CustomEvent('pocketry:gallery_view', { detail: { index: stageIndex + 1, total: galleryButtons.length, alt: button.dataset.galleryAlt || (button.dataset.galleryVideo ? 'video' : `image ${stageIndex + 1}`) } }));
      clearStageVideo();
      if (button.dataset.galleryVideo) {
        const tpl = document.getElementById(button.dataset.galleryVideo);
        if (tpl && stageEl) {
          stageVideo = tpl.content.firstElementChild.cloneNode(true);
          stageVideo.classList.add('pgrp__stage-video');
          mainImage.hidden = true;
          stageEl.insertBefore(stageVideo, mainImage);
          stageVideo.play && stageVideo.play().catch(() => {});
        }
      }
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = button.dataset.galleryImage;
      mainImage.alt = button.dataset.galleryAlt || root.dataset.outfitName;
      root.querySelectorAll('[data-gallery-image]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (previewBadge) previewBadge.hidden = true;
      if (galleryStatus) galleryStatus.textContent = `Now showing ${mainImage.alt}.`;
    });
  });

  // ── Mobile swipe gallery (M01 + M04, 2026-09-10) ───────────────────────
  // Full-width scroll-snap track; counter, dots and the truncated thumbnail
  // strip follow the scroll position (Baymard: dots alone give no scent).
  const swipe = root.querySelector('[data-swipe]');
  const track = swipe ? swipe.querySelector('[data-swipe-track]') : null;
  if (swipe && track) {
    const slides = Array.from(track.querySelectorAll('.pgrp__swipe-slide'));
    const count = swipe.querySelector('[data-swipe-count]');
    const dotsWrap = swipe.querySelector('[data-swipe-dots]');
    const thumbs = Array.from(swipe.querySelectorAll('[data-swipe-to]'));
    const dots = slides.map(() => { const dot = document.createElement('i'); dotsWrap && dotsWrap.appendChild(dot); return dot; });
    let current = 0;
    const sync = () => {
      const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      if (index === current && count && count.textContent) return;
      current = index;
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
      // Journey tracking (2026-09-14): which gallery image the visitor is looking at.
      const media = slides[index] && slides[index].querySelector('img, video');
      window.dispatchEvent(new CustomEvent('pocketry:gallery_view', { detail: { index: index + 1, total: slides.length, alt: (media && (media.getAttribute('alt') || (media.tagName === 'VIDEO' ? 'video' : ''))) || `image ${index + 1}` } }));
      dots.forEach((dot, k) => dot.classList.toggle('is-active', k === index));
      thumbs.forEach((thumb) => {
        const active = Number(thumb.dataset.swipeTo) === index;
        thumb.classList.toggle('is-active', active);
        if (active && thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
    };
    track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
    track.addEventListener('scroll', () => {
      slides.forEach((slide, k) => { const v = slide.querySelector('video'); if (v && k !== current && !v.paused) v.pause(); });
    }, { passive: true });
    const stepSwipe = (delta) => { const n = Math.max(0, Math.min(slides.length - 1, current + delta)); track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); };
    swipe.querySelector('[data-swipe-prev]')?.addEventListener('click', () => stepSwipe(-1));
    swipe.querySelector('[data-swipe-next]')?.addEventListener('click', () => stepSwipe(1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      track.scrollTo({ left: Number(thumb.dataset.swipeTo) * track.clientWidth, behavior: 'smooth' });
    }));
    sync();

  }

  // 2026-09-12 (owner): the gallery no longer shows the generating state or the finished
  // preview — both live in the portrait block under the gallery, so the portrait is shown once.
})();
